module.exports = __webpack_public_path__ + "static/img/fish23.a9b2b92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish23.png
// module id = Ol6L
// module chunks = 0